import { Reducer } from 'redux';
import ECActionTypes from './types';
import { EmergencyContactsState } from './types';

export const initialState: EmergencyContactsState = {
  ecLoading: false,
  GeoJSONPoints: undefined,
  contacts: undefined,
  error: undefined,
  geocode: undefined
};

const reducer: Reducer<EmergencyContactsState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case ECActionTypes.SET_EMERGENCY_CONTACTS_GEO_JSON: {
      return {
        ...state,
        GeoJSONPoints: action.payload
      };
    }

    case ECActionTypes.EMERGENCY_CONTACTS_START: {
      return {
        ...state,
        ecLoading: true
      };
    }

    case ECActionTypes.EMERGENCY_CONTACTS_SUCCESS: {
      return {
        ...state,
        ecLoading: false,
        contacts: action.payload,
        error: undefined
      };
    }
    case ECActionTypes.EMERGENCY_CONTACTS_FAILURE:
      return {
        ...state,
        ecLoading: false,
        error: action.payload || undefined
      };
    case ECActionTypes.GET_EC_GEOCODE_SUCCESS:
      return {
        ...state,
        geocode: action.payload
      };
    case ECActionTypes.GET_EC_GEOCODE_FAILURE:
      return {
        ...state,
        geocode: action.payload
      };
    case ECActionTypes.CLEAR_EC_GEOCODE:
      return {
        ...state,
        geocode: undefined
      };
    case ECActionTypes.CLEAR_EC_DATA:
      return {
        ...state,
        GeoJSONPoints: undefined,
        contacts: undefined,
        error: undefined,
        geocode: undefined
      };
    default:
      return state;
  }
};

export { reducer as EmergencyContactsReducer };
